export default __webpack_public_path__ + "static/media/mq.46b7025e.svg";